import { createSlice } from "@reduxjs/toolkit";

const loadDataFromLS = () => {
  try {
    const dataFromLS = JSON.parse(localStorage.getItem("formValues"));
    if (dataFromLS === null) {
      return( {
        full_name: "",
        email: "",
        motivation: "",
        occupation: "",
        course_title: "",
        phone: "",
        x_post_link: "",
        linkedin_post_link: "",
      });
    }
    return dataFromLS;
  } catch (error) {
    console.error("loading from local storage: " + error);
    return {
      full_name: "",
      email: "",
      motivation: "",
      occupation: "",
      course_title: "",
      phone: "",
      x_post_link: "",
      linkedin_post_link: "",
    };
  }
};

const initialState = {
  formValues: loadDataFromLS(),
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    updateFormValues(state, action) {
      state.formValues = { ...state.formValues, ...action.payload };

      //store data in theusers local storage
      localStorage.setItem("formValues", JSON.stringify(state.formValues));
    },
    resetFormValues(state) {
      state.formValues = {
        full_name: "",
        email: "",
        motivation: "",
        occupation: "",
        course_title: "",
        phone: "",
        x_post_link: "",
        linkedin_post_link: "",
      };

      //remove user data from local Storage
      localStorage.setItem("formValues", JSON.stringify(state.formValues));
    },
  },
});

export const { updateFormValues, resetFormValues } = formSlice.actions;
export default formSlice.reducer;
